export default __webpack_public_path__ + "static/media/puppyMaleRed.e7027619.jpg";